import { Model } from '@vuex-orm/core';
import ProductMaterialAPI, { ProductMaterialFilters } from '@/api/ProductMaterialAPI';

export interface ProductMaterialPaginationResult {
    total: number;
}

export default class ProductMaterial extends Model {
    public static entity = 'productMaterial';

    public static fields() {
        return {
            articleNumber: this.string(''),
            commodityGroup: this.string(''),
            matchcode: this.string(''),
            price1: this.attr(null),
            price2: this.attr(null),
            productGroup: this.string(''),
            updatedAt: this.string(''),
            images: this.attr([]),
        };
    }

    public static async getAll(
        page: number = 1,
        pageSize: number = 10,
        filters?: ProductMaterialFilters,
    ): Promise<ProductMaterialPaginationResult> {
        let allProductMaterials;

        try {
            allProductMaterials = await ProductMaterialAPI.getAll(page, pageSize, filters);
        } catch (e) {
            return Promise.reject(e);
        }

        // New response structure: { items: [...], total: number }
        const items = allProductMaterials.data?.items ?? allProductMaterials.data;
        const total = allProductMaterials.data?.total ?? items?.length ?? 0;

        this.create({ data: items });

        return Promise.resolve({ total: Number(total) });
    }

    public articleNumber!: string;
    public commodityGroup!: string;
    public matchcode!: string;
    public price1!: any[];
    public price2!: any[];
    public productGroup!: string;
    public updatedAt!: string;
    public images!: string[];
}
